import Component from 'flarum/Component';

export default class ChatMessageReactions extends Component {
    oninit(vnode) {
        super.oninit(vnode);
        this.model = this.attrs.model;
        this.showPicker = false;
    }

    oncreate(vnode) {
        super.oncreate(vnode);
        this._onClickOutside = (e) => {
            if (this.showPicker && !this.element.contains(e.target)) {
                this.showPicker = false;
                this.model.freshness = new Date();
                m.redraw();
            }
        };
        document.addEventListener('click', this._onClickOutside);
    }

    onremove(vnode) {
        super.onremove(vnode);
        document.removeEventListener('click', this._onClickOutside);
    }

    view() {
        this.model = this.attrs.model;
        const reactionCounts = this.model.reactionCounts() || {};
        const availableReactions = app.forum.attribute('chatReactions') || [];
        const hasReactions = Object.keys(reactionCounts).length > 0;

        if (!app.session.user && !hasReactions) return null;

        return (
            <div className="ChatMessage-reactions">
                {Object.keys(reactionCounts).map(reactionId => {
                    const data = reactionCounts[reactionId];
                    const reaction = availableReactions.find(r => String(r.id) === String(reactionId));
                    if (!reaction || data.count === 0) return null;

                    const tooltip = (data.users || []).filter(Boolean).join(', ');

                    return (
                        <button
                            className={'ChatMessage-reaction' + (data.reacted ? ' reacted' : '')}
                            onclick={(e) => { e.preventDefault(); this.toggleReaction(reactionId); }}
                            title={tooltip}
                        >
                            {this.renderEmoji(reaction)}
                            <span className="ChatMessage-reaction-count">{data.count}</span>
                        </button>
                    );
                })}
                {app.session.user ? (
                    <div className="ChatMessage-reaction-add-wrapper">
                        <button
                            className="ChatMessage-reaction-add"
                            onclick={(e) => { e.stopPropagation(); this.showPicker = !this.showPicker; this.model.freshness = new Date(); }}
                        >
                            <i class="far fa-smile"></i>
                        </button>
                        {this.showPicker ? (
                            <div className="ChatMessage-reaction-picker">
                                {availableReactions.map(reaction => (
                                    <button
                                        className="ChatMessage-reaction-picker-item"
                                        onclick={(e) => { e.preventDefault(); this.toggleReaction(reaction.id); }}
                                        title={reaction.identifier}
                                    >
                                        {this.renderEmoji(reaction)}
                                    </button>
                                ))}
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        );
    }

    renderEmoji(reaction) {
        if (reaction.type === 'emoji') {
            const cdnUrl = app.data['fof-reactions.cdnUrl'];
            if (cdnUrl && reaction.codepoint) {
                const url = cdnUrl.replace('[codepoint]', reaction.codepoint.toLowerCase());
                return <img className="reaction-emoji" src={url} alt={reaction.identifier} loading="lazy" />;
            }
            // Fallback: convert codepoint to native unicode
            if (reaction.codepoint) {
                try {
                    return String.fromCodePoint(parseInt(reaction.codepoint, 16));
                } catch (e) {}
            }
            return ':' + reaction.identifier + ':';
        }
        return <i class={reaction.identifier}></i>;
    }

    toggleReaction(reactionId) {
        this.showPicker = false;
        this.model.freshness = new Date();

        app.request({
            method: 'POST',
            url: app.forum.attribute('apiUrl') + '/chatmessages/' + this.model.id() + '/reactions',
            body: { data: { reactionId: reactionId } },
        }).then(response => {
            if (response.data && response.data.attributes) {
                this.model.pushData(response.data);
            }
            m.redraw();
        });
    }
}
